// extracted by mini-css-extract-plugin
module.exports = {"anchorNav":"styles_anchorNav__78oAx","title":"styles_title__3lYiD","list":"styles_list__2nhhG","link":"styles_link__IHWrd"};